import React, { useState } from 'react'
import { useLocation } from 'react-router-dom';
import FormAlamat from './form/FormAlamat';
import FormRegisMember from './form/FormRegisMember';
import FormPengiriman from './form/FormPengiriman';
import Payment from './form/Payment';
import './merchandise.css';

/* ─── Custom Stepper ─────────────────────────────────────── */
const CheckoutStepper = ({ steps, activeStep }) => (
    <div className="co-stepper-wrap">
        {steps.map((step, i) => {
            const isDone = i < activeStep;
            const isActive = i === activeStep;
            return (
                <React.Fragment key={i}>
                    <div className={`co-step ${isDone ? 'done' : ''} ${isActive ? 'active' : ''}`}>
                        <div className="co-step-circle">
                            {isDone
                                ? <i className="bi bi-check-lg" />
                                : <span>{i + 1}</span>
                            }
                        </div>
                        <span className="co-step-label">{step.label}</span>
                    </div>
                    {i < steps.length - 1 && (
                        <div className={`co-step-line ${isDone ? 'done' : ''}`} />
                    )}
                </React.Fragment>
            );
        })}
    </div>
);

/* ─── Checkout Page ──────────────────────────────────────── */
const Checkout = () => {
    const location = useLocation();
    const items = location.state.items;
    const isMember = location.state.isMember;
    const cartTotal = location.state.cartTotal;

    const steps = isMember
        ? [
            { label: 'Alamat' },
            { label: 'Pengiriman' },
            { label: 'Registrasi Member' },
            { label: 'Pembayaran' },
        ]
        : [
            { label: 'Alamat' },
            { label: 'Pengiriman' },
            { label: 'Pembayaran' },
        ];

    const [activeStep, setActiveStep] = useState(0);
    const [infoAlamat, setInfoAlamat] = useState({});
    const [registrasi, setRegistrasi] = useState({});
    const [kurir, setKurir] = useState({});
    const [ongkir, setOngkir] = useState({ ongkir: 0, total: cartTotal });

    const order = {
        destination_contact_name: infoAlamat.nama_lengkap,
        destination_contact_phone: infoAlamat.notelp ?? '',
        destination_address: infoAlamat.alamat ?? '',
        destination_contact_email: infoAlamat.email ?? '',
        destination_postal_code: infoAlamat.postal_code ?? '',
        courier_company: ongkir.courier_code ?? '',
        courier_type: ongkir.courier_type ?? '',
        courier_insurance: 500000,
        delivery_type: 'now',
        ongkir: ongkir.ongkir,
        items,
    };

    const nextStep = () => setActiveStep(prev => prev + 1);

    const getSectionComponent = () => {
        switch (activeStep) {
            case 0: return <FormAlamat setKurir={setKurir} items={items} nextStep={nextStep} infoAlamat={infoAlamat} setInfoAlamat={setInfoAlamat} />;
            case 1: return <FormPengiriman kurir={kurir} ongkir={ongkir} setOngkir={setOngkir} nextStep={nextStep} cartTotal={cartTotal} />;
            default: return null;
        }
    };

    const getSectionComponentRegis = () => {
        switch (activeStep) {
            case 0: return <FormAlamat setKurir={setKurir} items={items} nextStep={nextStep} infoAlamat={infoAlamat} setInfoAlamat={setInfoAlamat} />;
            case 1: return <FormPengiriman kurir={kurir} ongkir={ongkir} nextStep={nextStep} setOngkir={setOngkir} cartTotal={cartTotal} />;
            case 2: return <FormRegisMember infoAlamat={infoAlamat} setRegistrasi={setRegistrasi} nextStep={nextStep} />;
            default: return null;
        }
    };

    const isLastStep = isMember ? activeStep === 3 : activeStep === 2;
    const showFormCol = isMember ? activeStep !== 3 : activeStep !== 2;

    return (
        <section className="co-page">
            {/* ── Hero Banner ── */}
            {/* <div className="co-hero">
                <div className="co-hero-overlay" />
                <div className="container co-hero-inner">
                    <p className="co-hero-eyebrow">
                        <i className="bi bi-bag-heart-fill me-2" />
                        NIEC Merchandise
                    </p>
                    <h1 className="co-hero-title">Checkout</h1>
                    <p className="co-hero-sub">Selesaikan pesananmu dalam beberapa langkah mudah</p>
                </div>
            </div> */}

            <div className="container co-content">
                {/* ── Stepper ── */}
                <CheckoutStepper steps={steps} activeStep={activeStep} />

                {/* ── Main Grid ── */}
                <div className="co-grid">
                    {/* Left column – form */}
                    {showFormCol && (
                        <div className="co-col-form">
                            {isMember
                                ? getSectionComponentRegis()
                                : getSectionComponent()
                            }
                        </div>
                    )}

                    {/* Right column – order summary */}
                    <div className={`co-col-summary ${isLastStep ? 'co-col-full' : ''}`}>
                        <Payment
                            ongkir={ongkir}
                            items={items}
                            activeStep={activeStep}
                            registrasi={registrasi}
                            isMember={isMember}
                            order={order}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Checkout;
